var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"conte",domProps:{"innerHTML":_vm._s(_vm.data.content)}})
}
var staticRenderFns = []

export { render, staticRenderFns }